import React from "react";

import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";

class InitClusterChart extends React.PureComponent {
  render() {
    const { id, dataset, fill, cData, initCluster, selected } = this.props;

    let isContinuous = true;

    if (
      dataset &&
      dataset.fields &&
      dataset.outcome &&
      dataset.fields[dataset.outcome] &&
      dataset.fields[dataset.outcome].type === "categorical"
    ) {
      isContinuous = false;
    }

    return (
      <div className={styles.runPlot + " " + styles.initCluster}>
        {dataset && dataset.isClusterLoading ? (
          <LoadingIndicator style={{ margin: "0px" }} />
        ) : (
          <Button
            type={"secondary"}
            active
            title={"Unable to run cluster graph on a regression"}
            disabled={isContinuous}
            onClick={() => initCluster(dataset && dataset.id)}
          >
            {"Start Cluster Chart"}
          </Button>
        )}
      </div>
    );
  }
}

export default InitClusterChart;
